<template>
<div :class="primitiveBaseClasses">
        <span>
            <div>
                <label class="amf-input-label" v-if="$_showLabel">{{label}}</label>
                <select ref="select" :class="['form-control', { error: hasError }]" :title="label" v-model="selectedObj" :disabled="$_disabled">
                  <option v-if="caption" :value="null">{{ caption }}</option>
                  <option v-for="option in selectOptions" :key="option.id" :value="returnObject ? option : option.id" :selected="option.id === value" :disabled="option.disabled">{{ option.name }}</option>
                </select>
                <div class="error-div">
                    {{validationMessage}}
                </div>
            </div>

        </span>
</div>
</template>

<script>
import primitiveMixin from './primitive-mixin'

export default {
    mixins:[primitiveMixin],
    props: {
        value: [String, Number, Object, Boolean],
        mapId: { type: String, default: null },
        mapName: { type: String, default: null },
        enumName: String,
        label: String,
        options: { type: Array, required: true },
        caption: { type: String, default: null },
        returnObject: { type: Boolean, default: false },
    },
    computed: {
        selectOptions() {
            if(this.enumName) {
                let options = this.lookup(this.enumName).all();
                let enumOptions = mapToSelect(options, 'name', 'description');
                return enumOptions;
            }
            else {
                if(this.mapId) {
                    return mapToSelect(this.options, this.mapId, this.mapName);
                }
                else if(this.mapName) {
                    return mapToSelect(this.options, 'id', this.mapName);
                }
                else {
                    return this.options;
                }
            }
        },
    },
    data() {
        return {
            selectedObj: this.value
        }
    },
    watch: {
        selectedObj(newValue) {
            this.changeMade({ name: this.label, value: newValue });
            this.$emit('input', newValue);
        },
        value(newValue) {
            this.selectedObj = newValue;
        },
        selectOptions(newValue, oldValue) {
            if(this.enumName && (!oldValue || oldValue.length == 0) && (newValue && newValue.length > 0)){
                this.selectedObj = this.value;
            }
        }
    }
}

function mapToSelect(values, mapId, mapName = null) {
    return values.map(option => {
        let value = { ...option };
        let displayText = '';
        if(mapName) {
            displayText = value[mapName];
        }
        else if(value.name) {
            displayText = value.name;
        }
        else if(value.description) {
            displayText = value.description;
        }
        value.id = value[mapId];
        value.name = displayText;
        return value;
    });
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfSelect.vue